import React from 'react';

const TestSeriesCardKeyPoints = props => {
    const { sections, keyPoints } = props;
    return (
        <div className="card-details border-btm">
            <ul>
                {
                    sections.map((section, key) => {
                        return (<li key={key}>{section.quizCount} {section.name}</li>);
                    })
                }
                {
                    keyPoints.slice(0, 4).map((point, key) => {
                        return (
                            <li className="remove-key-features" key={key}>{point}</li>
                        );
                    })
                }
            </ul>
        </div>
    );
};
export default TestSeriesCardKeyPoints;
